/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientEmailRepeater/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import Repeater from 'DesignSystem/Repeater/index'



/** @type {import('Simple/types.js').View} */
export default function PatientEmailRepeater({
  children,
  viewPath = "/App/Form/Data/ReviewData/PatientEmailRepeater",
  text
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<Repeater
  viewPath={`${viewPath}/Repeater`}
 label="Patient's Email Address"
 onClick={() => setFlowTo("/App/Form/Data/ProvideData/PatientEmail")}
 isSelected={flow.has("/App/Form/Data/ProvideData/PatientEmail")}
 text={text}
 textTransform="none"
/>
{children}
</React.Fragment>)
}